"use client";

/**
 * Main Page - Chat Interface with Voice Recording
 */

import ChatInterface from "@/components/ChatInterface";

export default function Home() {
  return <ChatInterface />;
}
